<template>
    <div>
        <!-- <vue-headful v-bind:title="$t('page-not-found.metadata.title')" v-bind:description="$t('page-not-found.metadata.description')" ogLocale="sv_SE" lang="sv-SE"/>         -->
 
        <Hero img="/images/gone.jpeg" v-bind:title="$t('page-not-found.hero.title')" v-bind:preamble="$t('page-not-found.hero.preamble')" v-bind:body="$t('page-not-found.hero.body')" />

         <section id="not-found">
            <div class="container">
                <div class="section-content">
                    <h2>{{$t("page-not-found.content.title")}}</h2>
                    <p>{{$t("page-not-found.content.text")}} <router-link to="/contact">{{$t("page-not-found.content.contact")}}</router-link>.</p>
                    <div v-html="$t('page-not-found.content.html')" ></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Hero from '../components/Hero.vue'

    export default {
        name: 'app',
        components: {
            Hero
        }
    }
</script>

<style scoped>
</style>